import { AttachmentListItem, AttachmentListItemProps } from './AttachmentListItem';

interface AttachmentListProps extends Pick<AttachmentListItemProps, 'storeId' | 'msgId'> {
  list: Conversation.MsgAttachmentInfo[];
}

export const AttachmentList = (props: AttachmentListProps) => {
  const { list, ...others } = props;

  return (
    <div className="flex gap-2 mt-1 px-[10px] py-[8px] bg-fill-0 rounded">
      {list.map((data) => (
        <AttachmentListItem key={data.filename} data={data} {...others} />
      ))}
    </div>
  );
};
